module.exports = __webpack_public_path__ + "staticcomp/img/content_4.d266044.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/5/content_4.jpg
// module id = 2FGp
// module chunks = 39